import React from "react";
import styles from './imagePreview.module.scss';
import {ReactComponent as ImageWithError} from "../../../assets/promos&items/image_error.svg";
import {AsyncImageWithLoader} from "../../../com/imageWithLoader/imageWithLoader";
import {FlyerPageSpotDto} from "../../../dtos";
import {NonImagePlaceholder} from "../nonImagePlaceholder/nonImagePlaceholder";

interface Props {
    src: string;
    selectedPageImage?: string;
    frame?: FlyerPageSpotDto;
}


export const ImagePreviewPopup: React.FC<Props> = (
    {
        src,
        selectedPageImage,
        frame
    }
) => {
    return (
        <div className={`${styles.item_tooltip_preview_popup} layout_flex_row`}>
            <div>
                <div className={`layout_flex_row ${styles.row_with_image}`}>
                    <div className={styles.image_wrapper}>
                        <AsyncImageWithLoader
                            src={src}
                            notUploadIcon={(<NonImagePlaceholder/>)}
                            // selectedPageImage={selectedPageImage}
                            // frame={frame}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}